import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import LogoutPage from 'views/pages/Logout';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const AuthResetPassword3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/ResetPassword3')));
const AuthSetPassword3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/SetPassword3')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <AuthLogin3 />
        },
        {
            path: '/reset-password',
            element: <AuthResetPassword3 />
        },
        {
            path: '/set-password',
            element: <AuthSetPassword3 />
        },
        {
            path: '*',
            element: <LogoutPage />
        }
    ]
};

export default AuthenticationRoutes;
